'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toArray = exports.linkToSizeChart = exports.getSlidesForSize = exports.setHeaderContentHeight = exports.setTimerCountdownInfo = exports.setAllLinkTargets = exports.isMobileDevice = exports.handlize = exports.random = exports.getHandle = exports.setSearchParm = exports.getSearchParm = exports.debounce = exports.toggleElement = exports.unique = exports.getAlternativeTemplate = exports.$$ = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $$ = exports.$$ = function $$(selector) {
  var nodes = document.querySelectorAll(selector);
  return Array.from(nodes);
};

var getAlternativeTemplate = exports.getAlternativeTemplate = function getAlternativeTemplate(_ref) {
  var resource = _ref.resource,
      templateName = _ref.templateName,
      _ref$json = _ref.json,
      json = _ref$json === undefined ? false : _ref$json;

  var url = '/' + resource + '?view=' + templateName;
  var options = { credentials: 'include' };
  return fetch(url, options).then(function (res) {
    return json ? res.json() : res.text();
  });
};

var unique = exports.unique = function unique(array) {
  return [].concat((0, _toConsumableArray3.default)(new Set(array)));
};

var toggleElement = exports.toggleElement = function toggleElement(_ref2) {
  var selector = _ref2.selector,
      _ref2$className = _ref2.className,
      className = _ref2$className === undefined ? _Dom2.default.isActive : _ref2$className,
      _ref2$action = _ref2.action,
      action = _ref2$action === undefined ? 'toggle' : _ref2$action,
      _ref2$animated = _ref2.animated,
      animated = _ref2$animated === undefined ? false : _ref2$animated;

  var normalizedclassName = className[0] === '.' ? className.slice(1) : className;
  var normalizedSelectorString = className[0] !== '.' ? '.' + className : className;

  var impossibleAdd = $(selector).is(normalizedSelectorString) && action == 'add';
  var impossibleRemove = !$(selector).is(normalizedSelectorString) && action == 'remove';

  if (impossibleAdd || impossibleRemove) {
    return Promise.resolve({});
  }

  var toggleClass = function toggleClass() {
    if (action === 'toggle') {
      $(selector).toggleClass(normalizedclassName);
    } else if (action === 'add') {
      $(selector).addClass(normalizedclassName);
    } else if (action === 'remove') {
      $(selector).removeClass(normalizedclassName);
    }
  };

  if (animated) {
    return new Promise(function (resolve) {
      $(selector).one('transitionend', function () {
        return resolve({ selector: selector, className: className, action: action, animated: animated });
      });
      toggleClass();
    });
  }

  toggleClass();

  return Promise.resolve({ selector: selector, className: className, action: action, animated: animated });
};

var debounce = exports.debounce = function debounce(callback) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  var interval = arguments[2];
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(interval);
    interval = setTimeout(function () {
      return callback.apply(undefined, args);
    }, time);
  };
};

var getSearchParm = exports.getSearchParm = function getSearchParm(params) {
  var searchParams = new URLSearchParams(window.location.search);

  return typeof params === 'string' ? searchParams.get(params) : params.reduce(function (params, param) {
    return Object.assign({}, params, (0, _defineProperty3.default)({}, param, searchParams.get(param.toLowerCase())));
  }, {});
};

var setSearchParm = exports.setSearchParm = function setSearchParm(param, value) {
  var searchParams = new URLSearchParams(window.location.search);
  searchParams.set(param, value);
  window.history.pushState('', '', '?' + searchParams.toString());
  return searchParams;
};

var getHandle = exports.getHandle = function getHandle() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'product';

  if (type === 'collection') {
    return window.location.pathname.replace(/\/collections\/(.*)\/?/, '$1');
  } else if (type === 'product') {
    return window.location.pathname.replace(/\/products\/(.*)\/?/, '$1');
  }
  return window.location.pathname.replace(/\/products\/(.*)\/?/, '$1');
};

var random = exports.random = function random() {
  var digits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 9;

  return Math.floor(Math.random() * Math.pow(10, digits));
};

var handlize = exports.handlize = function handlize(string) {
  return string.trim().toLowerCase().replace(/[\s_]/g, '-');
};

var isMobileDevice = exports.isMobileDevice = function isMobileDevice() {
  return window.innerWidth <= 1050;
};

var setAllLinkTargets = exports.setAllLinkTargets = function setAllLinkTargets() {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '_blank';

  var allLinks = document.querySelectorAll('a');
  allLinks.forEach(function (link) {
    link.setAttribute('target', target);
  });
};

var setTimerCountdownInfo = exports.setTimerCountdownInfo = function setTimerCountdownInfo() {
  var countdowns = document.querySelectorAll('[data-timer-ends]');
  var now = new Date(new Date().toLocaleString('en-US', { timeZone: "America/Denver" }));
  countdowns.forEach(function (countdown) {
    var date = countdown.getAttribute('data-timer-ends');
    var drawing = new Date(date.toLocaleString('en-US', { timeZone: "America/Denver" }));
    var secondsTill = Math.max(0, Math.round(drawing.getTime() - now.getTime()) / 1000);
    countdown.setAttribute('data-timer', secondsTill);
  });
};

var setHeaderContentHeight = exports.setHeaderContentHeight = function setHeaderContentHeight() {
  var header = document.querySelector('[data-header-wrapper]');
  var headerHeight = header.clientHeight;
  document.documentElement.style.setProperty('--content-body-padding', headerHeight + 'px');
};

var slideBreakpoints = [{
  slides: 1,
  width: 0
}, {
  slides: 2,
  width: 768
}, {
  slides: 4,
  width: 992
}];
var getSlidesForSize = exports.getSlidesForSize = function getSlidesForSize() {
  var screenWidth = window.innerWidth;
  return slideBreakpoints.reduce(function (largestFound, breakpoint) {
    if (largestFound === false) {
      return breakpoint;
    }
    if (screenWidth > breakpoint.width && breakpoint.width > largestFound.width) {
      return breakpoint;
    }
    return largestFound;
  }, false);
};

var linkToSizeChart = exports.linkToSizeChart = function linkToSizeChart() {
  var toLinkTo = document.querySelector(_Dom2.default.sizeGuide) || false;
  var distanceToTop = toLinkTo ? toLinkTo.getBoundingClientRect().y : false;
  distanceToTop && window.scrollTo({
    top: distanceToTop - 100,
    left: 0,
    behavior: 'smooth'
  });
};

var toArray = exports.toArray = function toArray(nodelist) {
  return [].slice.call(nodelist);
};